import { Sdk } from '@hivebrite/frontend-sdk';

export const sdk = new Sdk('client');
